import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function EditPinjamanBarang() {
  const { id, iduser } = useParams();
  const history = useHistory();
  const PEMBIAYAAN = 4;
  const BENDAHARA = 5;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [listLamaCicilan, setListLamaCicilan] = useState([
    { label: "3 - Bulan", value: 3 },
    { label: "6 - Bulan", value: 6 },
    { label: "9 - Bulan", value: 9 },
    { label: "12 - Bulan", value: 12 },
    { label: "18 - Bulan", value: 18 },
    { label: "24 - Bulan", value: 24 },
  ])
  const [empBesarPlafond, setEmpBesarPlafond] = useState(0);
  const [empLamaCicilan, setEmpLamaCicilan] = useState(0);
  const [empSetorPlafond, setEmpSetorPlafond] = useState("NaN");
  const [empSetorTotal, setEmpSetorTotal] = useState("NaN");
  const [empData, setEmpData] = useState([]);
  const [jasaBulan, setJasaBulan] = useState("NaN");
  const [ajuanData, setAjuanData] = useState([]);
  const [settingBiaya, setSettingBiaya] = useState();
  const [newData, setNewData] = useState({
    plafond: "",
    lama:0,
    cpokok: "",
    cicilan: "",
    jasa_bulan: "",
    created_at: "",
    trxdetailbarang: "",
    jenis_barang: "",
    spesifikasi_barang: "",
    status: "",
  });


  // CONTROLLER

  const fetchData = async (id_user, id) => {
    setIsLoading(true);

      await axios
      .all(
        [
        baseAPI .get(`/v1/user/${id_user}`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/ajuanpinjambarang/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/csetting`, { headers: { Authorization: `Bearer ${token}` } }),
      ]
      )
      .then((res) => {
        const dataUser = res[0].data.data.userData;       
        const dataAjuan = res[1].data.data.ajuanpinjam;
        const dataBiaya = res[2].data.data.dataSetting;

        let lamaCicil = []
        listLamaCicilan.map(e => {
          if(e.value == dataAjuan[0].lama) {
            lamaCicil.push({ label: e.label, value: e.value })
          }
        });

        dataBiaya.map(e => {
          if (e.nama_biaya === "Max Harga Barang") {
            setSettingBiaya(e.biaya);
          }
        });

        setEmpSetorPlafond(parseFloat(dataAjuan[0].cpokok).toLocaleString('id-ID'))
        setEmpSetorTotal(parseFloat(dataAjuan[0].cpokok + dataAjuan[0].jasa_bulan).toLocaleString('id-ID'));
        setEmpBesarPlafond(parseFloat(dataAjuan[0].plafond).toLocaleString('id-ID'));
        setJasaBulan(parseFloat(dataAjuan[0].jasa_bulan).toLocaleString('id-ID'));
        setEmpLamaCicilan(lamaCicil[0]);
        setEmpData(dataUser[0]);
        setAjuanData(dataAjuan[0]);
        setNewData({...newData,
          plafond: dataAjuan[0].plafond,
          lama: dataAjuan[0].lama,
          cpokok: dataAjuan[0].cpokok,
          cicilan_ke: dataAjuan[0].cicilan_ke,
          cicilan: dataAjuan[0].cpokok + dataAjuan[0].jasa_bulan,
          jasa_bulan: dataAjuan[0].jasa_bulan,
          created_at: dataAjuan[0].created_at,
          trxdetailbarang: dataAjuan[0].trxdetailbarang,
          spesifikasi_barang: dataAjuan[0].spesifikasi_barang,
          jenis_barang: dataAjuan[0].jenis_barang,
          status: dataAjuan[0].status,
          npp_anggota: dataAjuan[0].npp_anggota,
          notrxdetailbarang: dataAjuan[0].notrxdetailbarang,
          id_users: dataAjuan[0].id_users,
        });
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const updatePinjaman = async (id, idUser, status) => {

    Swal.fire({
      title: 'Apakah anda akan ' + status + ' pinjaman ini?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Ya',
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('update_data', JSON.stringify(newData));
        body.append('status', status == "melunasi" ? "Lunas" : "Update");

        baseAPI
          .put(`/v1/detailpinjambarang/${id}/${idUser}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Data pengajuan pinjaman berhasil diperbarui.",
              showConfirmButton: false,
              timer: 1500
            })
            fetchData(idUser, id);
            console.log(`berhasil upload ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Data pengajuan pinjaman gagal diperbarui.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchData(idUser, id);
          })
      }
    });

  }

  const handleFormat = (plafond, lama, jasa) => {

    const numericValue = plafond.replace(/[^0-9]/g, '');
    let rupiahPlafond = parseFloat(numericValue).toLocaleString('id-ID');
    const jasaValue = jasa.replace(/[^0-9]/g, '');
    let rupiahJasa = parseFloat(jasaValue).toLocaleString('id-ID');
    setJasaBulan(rupiahJasa);
    setEmpBesarPlafond(rupiahPlafond);

    if (parseFloat(numericValue) > settingBiaya) {
      Swal.fire({
        icon: 'error',
        title: "Besar estimasi harga barang tidak boleh lebih dari Rp.35.000.000.",
        showConfirmButton: false,
        timer: 1500
      })
    } 
    else {
      if (lama > 12 && parseFloat(numericValue) <= 10000000) {
        Swal.fire({
          icon: 'error',
          title: "Lama cicilan lebih dari 9 bulan hanya untuk harga barang di atas Rp.10.000.000.",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        let ctotal = 0;
        let cpokok = 0;
        if (jasa !== 0) {
          ctotal = (parseFloat(numericValue) / lama) + parseFloat(jasaValue);
          cpokok = (parseFloat(numericValue) / lama);
          setEmpLamaCicilan({label: `${lama} - Bulan`, value: lama})
          setEmpSetorTotal(parseFloat(ctotal.toFixed()).toLocaleString('id-ID'));
          setEmpSetorPlafond(parseFloat(cpokok.toFixed()).toLocaleString('id-ID'));
        };
      }
    };

    if (parseFloat(numericValue) > 10000000) {
      setListLamaCicilan([
        { label: "3 - Bulan", value: 3 },
        { label: "6 - Bulan", value: 6 },
        { label: "9 - Bulan", value: 9 },
        { label: "12 - Bulan", value: 12 },
        { label: "24 - Bulan", value: 24 },
        { label: "36 - Bulan", value: 36 },
      ])
    } 
    else if (parseFloat(numericValue) <= 10000000) {
      setListLamaCicilan([
        { label: "3 - Bulan", value: 3 },
        { label: "6 - Bulan", value: 6 },
        { label: "9 - Bulan", value: 9 },
        { label: "12 - Bulan", value: 12 },
      ])
    };

  };
  
  useEffect(() => {
    if (user.role === PEMBIAYAAN || user.role === BENDAHARA) {
      fetchData(iduser, id);
    };
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Pinjaman Barang</Link> /{' '}
              <Link to='/pinjambarang/datapinjamanbarang' style={{ color: '#333' }}>Data Pinjaman Barang</Link> /{' '}
              <Link to='#' style={{ color: '#333' }}>Edit Pinjaman Barang</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const parsedDate = moment(newData.created_at, "YYYY-MM-DD HH:mm:ss");
  const defaultDate = parsedDate.isValid() ? parsedDate.toDate() : null;
  const parseAppDate = moment(newData.trxdetailbarang, "YYYY-MM-DD HH:mm:ss");
  const apprDate = parseAppDate.isValid() ? parseAppDate.toDate() : null;

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Edit Pinjaman Barang</b></p>
                <p>Silahkan update data pinjaman barang berikut.</p>
              </div>
              
              {/* Estimai Biaya Barang */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Estimasi Harga Barang<span className='text-danger'>*</span>
                </label>
                <input
                  className='form-control'
                  value={"Rp." + empBesarPlafond}
                  placeholder="Masukan estimasi harga barang"
                  onChange={e => {
                    handleFormat(e.target.value, newData.lama, "")
                    const numericValue = (e.target.value).replace(/[^0-9]/g, '');
                    setNewData({...newData, plafond: parseFloat(numericValue)})
                  }}
                />
              </div>

              {/* Lama cicilan biaya */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Lama Cicilan<span className='text-danger'>*</span>
                </label>
                <Select
                  isDisabled={empBesarPlafond === 0 || newData.plafond > settingBiaya ? true : false}
                  options={listLamaCicilan}
                  value={listLamaCicilan && empLamaCicilan}
                  placeholder="Pilih lama cicilan"
                  onChange={e => {
                    handleFormat(empBesarPlafond, e.value, "");
                    setNewData({...newData, lama: e.value});
                  }}
                />
              </div>

              {/* Tanggal pengajuan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Pengajuan<span className='text-danger'>*</span>
                </label>
                <DatePicker
                  selected={defaultDate}
                  placeholderText="Pilih tanggal"
                  className="form-control datepicker"
                  dateFormat="dd/MM/yyyy"
                  readOnly
                />
              </div>

              {/* Tanggal approved */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Approved
                </label>
                <DatePicker
                  selected={newData.status === "Diajukan" || newData.status === "Disetujui Pembiayaan" || newData.status === "Ditolak" ? null : apprDate}
                  placeholderText="-- menunggu approved --"
                  className="form-control datepicker"
                  dateFormat="dd/MM/yyyy"
                  readOnly
                />
              </div>

              {/* Name */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Name<span className='text-danger'>*</span>
                </label>
                <input
                  defaultValue={empData.name_anggota}
                  placeholder='Employee name'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Jenis Barang */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Jenis Barang<span className='text-danger'>*</span>
                </label>
                <input
                  defaultValue={newData.jenis_barang}
                  placeholder='Masukan jenis barang'
                  className="form-control"
                  onChange={(e) => setNewData({...newData, jenis_barang: e.target.value})}
                />
              </div>

              {/* Spesifikasi Barang */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Spesifikasi Barang (type, warna, dll)<span className='text-danger'>*</span>
                </label>
                <textarea
                  defaultValue={newData.spesifikasi_barang}
                  placeholder='Masukan spesifikasi barang'
                  className="form-control"
                  onChange={(e) => setNewData({...newData, spesifikasi_barang: e.target.value})}
                />
              </div>

              {/* Besar jasa per bulan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Besar Jasa per Bulan<span className='text-danger'>*</span>
                </label>
                <input
                  value={jasaBulan === "NaN" || jasaBulan === null ? "Rp.0" : "Rp." + jasaBulan}
                  placeholder='Masukan jasa bulan'
                  className="form-control"
                  onChange={(e) => {
                    handleFormat(empBesarPlafond, newData.lama, e.target.value)
                    const numericValue = (e.target.value).replace(/[^0-9]/g, '')
                    setNewData({...newData, jasa_bulan: parseFloat(numericValue)});}
                  }
                  />
              </div>

              {/* cicilan pokok per bulan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Cicilan Pokok per Bulan<span className='text-danger'>*</span>
                </label>
                <input
                  value={empSetorPlafond === "NaN" || empSetorPlafond === null ? "Rp.0" : "Rp." + empSetorPlafond}
                  placeholder='Masukan cicilan pokok per bulan'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* cicilan total per bulan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Cicilan Total per Bulan<span className='text-danger'>*</span>
                </label>
                <input
                  value={empSetorTotal === "NaN" || empSetorTotal === null ? "Rp.0" : "Rp." + empSetorTotal}
                  placeholder='Masukan cicilan total per bulan'
                  className="form-control"
                  readOnly
                />
              </div>

              <div className='col-md-6'>
                <button
                  disabled={newData.status === "Diajukan" || newData.status === "Disetujui Pembiayaan" ? (newData.lama !== 0 && newData.plafond !== "" && empSetorPlafond !== "NaN" && jasaBulan !== "NaN" && newData.jenis_barang !== "" && newData.spesifikasi_barang !== "" ? false : true) : true}
                  type="button"
                  className='btn btn-success col-md-12'
                  style={{backgroundColor: "#6A9C89"}}
                  onClick={() => {
                    updatePinjaman(ajuanData.id, iduser, "memperbarui")
                  }}
                >
                  Update
                </button>
              </div>

              <div className='col-md-6'>
                <button
                  disabled={newData.status !== "Lunas" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  onClick={() => {
                    updatePinjaman(ajuanData.id, iduser, "melunasi")
                  }}
                >
                  Ajukan Pelunasan
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default EditPinjamanBarang;